import { CreateActionParams } from '../actions';
import { TabTypes } from '../../types';
import { EventNames } from '../../core/fedops';
import { ExperimentsConsts } from '../../consts/experiments';

export type GetUpcoming = () => void;

export function createGetUpcomingAction({
  context,
  getControllerState,
}: CreateActionParams): GetUpcoming {
  return async () => {
    const { api, fedopsLogger, biLogger, flowAPI } = context;
    fedopsLogger?.interactionStarted(EventNames.UpcomingTabLoaded);
    const isCancellationFeesUoU = flowAPI.experiments.enabled(
      ExperimentsConsts.CancellationFeesUoU,
    );

    const [state, setState] = getControllerState();

    const { bookings, selectedTimezone, businessInfo } =
      await api.getEnrichedBookings({
        type: TabTypes.UPCOMING,
        applicationState: state,
        withBookingPolicySettings: isCancellationFeesUoU,
      });

    api.logTabLoadedBi({
      tabName: TabTypes.UPCOMING,
      data: bookings,
      biLogger,
    });

    setState({
      upcomingData: bookings,
      selectedTimezone,
      businessInfo,
    });

    fedopsLogger?.interactionEnded(EventNames.UpcomingTabLoaded);
  };
}
